export const identity = <E>(e: E) => e;
